<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781429983532_toc01#toctitle2" id="title2"><span><strong class="b">AUTOBIOGRAPHY, BIOGRAPHY, AND MEMOIRS</strong></span></a></div>
<div class="p"><span><br/><br/><br/></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429983532_p01.vue?edf0dea6